import {useEffect} from "react";

import {LoginForm} from "@components/LoginCard";
import {AuthCardLayout} from "@layouts/AuthCardLayout";

export function LoginPage() {
    useEffect(() => {
        document.title = "Login - Pecunio Agents";
    }, []);

    return (
        <AuthCardLayout>
            <LoginForm/>
        </AuthCardLayout>
    );
}